import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/seatMap', request)
}

async function post(request) {
    return await postMethod('/api/seatMap', request)
}

async function put(id, request) {
    return await putMethod(`/api/seatMap/${id}`, request)
}

export {get, post, put}
